import requester from '@/lib/axios';
import {
  DNDPositionalQuestion,
  PositionalQuestionCreateDTO,
} from '@/models/Question';

const baseUrl = 'dnd-positional-activity';
const nestedUrl = (activityId: number) => `activities/${activityId}/${baseUrl}`;

export const getPositionalQuestion = async (id: number) => {
  const { data } = await requester().get<DNDPositionalQuestion>(
    `${baseUrl}/${id}/`,
  );
  return data;
};

export const createPositionalQuestionIntoActivity = async (
  activityId: number,
  body: Partial<PositionalQuestionCreateDTO>,
) => {
  const { data } = await requester().post<DNDPositionalQuestion>(
    `${nestedUrl(activityId)}/`,
    body,
  );
  return data;
};

export const updatePositionalQuestionIntoActivity = async (
  activityId: number,
  id: number,
  changes: Partial<
    Pick<PositionalQuestionCreateDTO, 'title' | 'context' | 'feedbacks'>
  >,
) => {
  const { data } = await requester().patch<DNDPositionalQuestion>(
    `${nestedUrl(activityId)}/${id}/`,
    changes,
  );
  return data;
};

export const deletePositionalQuestionIntoActivity = async (
  activityId: number,
  id: number,
) => {
  await requester().delete(`${nestedUrl(activityId)}/${id}/`);
};
